'use strict';

var accordionContainer = '[data-faq-accordion]';
var accordionToggle = '.pd-faq-accordion__toggle';

function setAccordionState($accordion, shouldExpand) {
    var $toggle = $accordion.find(accordionToggle).first();
    var $panel = $accordion.find('.pd-faq-accordion-panel').first();
    var $chevron = $toggle.find('.pd-faq-accordion-chevron').first();

    $accordion.toggleClass('is-open', shouldExpand);
    $toggle.attr('aria-expanded', shouldExpand ? 'true' : 'false');
    $chevron.toggleClass('up', shouldExpand);

    if (!$panel.length || typeof $panel.collapse !== 'function') {
        return;
    }

    if (shouldExpand) {
        $panel.collapse('show');
    } else {
        $panel.collapse('hide');
    }
}

function handleKeyboardNavigation(event) {
    var key = event.key;
    var navigationKeys = ['ArrowDown', 'ArrowUp', 'Home', 'End'];

    if (navigationKeys.indexOf(key) === -1) {
        return;
    }

    var $toggles = $(accordionToggle).filter(':visible');
    if (!$toggles.length) {
        return;
    }

    var currentIndex = $toggles.index(event.currentTarget);
    if (currentIndex < 0) {
        return;
    }

    event.preventDefault();

    var nextIndex = currentIndex;
    if (key === 'ArrowDown') {
        nextIndex = (currentIndex + 1) % $toggles.length;
    } else if (key === 'ArrowUp') {
        nextIndex = currentIndex - 1;
        if (nextIndex < 0) {
            nextIndex = $toggles.length - 1;
        }
    } else if (key === 'Home') {
        nextIndex = 0;
    } else if (key === 'End') {
        nextIndex = $toggles.length - 1;
    }

    $toggles.eq(nextIndex).focus();
}

module.exports = function () {
    $(accordionContainer).each(function () {
        var $accordion = $(this);
        var $header = $accordion.find('.pd-faq-accordion-header').first();
        var ariaLevel = $header.data('aria-level');
        var isExpanded = $accordion.hasClass('is-open');

        if (/^[1-6]$/.test(String(ariaLevel))) {
            $header.attr('aria-level', ariaLevel);
        }

        setAccordionState($accordion, isExpanded);
    });

    $('body').off('click.plpFaqAccordion', accordionContainer + ' ' + accordionToggle);
    $('body').off('keydown.plpFaqAccordion', accordionContainer + ' ' + accordionToggle);

    $('body').on('click.plpFaqAccordion', accordionContainer + ' ' + accordionToggle, function (event) {
        var $accordion = $(this).closest(accordionContainer);
        var isExpanded = $(this).attr('aria-expanded') === 'true';
        var isKeyboardActivation = event.detail === 0;
        var willExpand = !isExpanded;

        setAccordionState($accordion, willExpand);

        if (willExpand && isKeyboardActivation) {
            $accordion.find('.pd-faq-accordion-body').first().focus();
        }
    });

    $('body').on('keydown.plpFaqAccordion', accordionContainer + ' ' + accordionToggle, handleKeyboardNavigation);
};
